import { render, staticRenderFns } from "./AccountConfirm.vue?vue&type=template&id=6621eb72&"
import script from "./AccountConfirm.vue?vue&type=script&lang=js&"
export * from "./AccountConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports